module.exports = __webpack_public_path__ + "1513bd11f4d9e3747b7610b4a1cc41a3.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/background/savanna.mp3
// module id = 3874
// module chunks = 0